import { Tooltip, styled, tooltipClasses } from "@mui/material";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: "#FFFFFF",
    fontSize: theme.typography.pxToRem(12),
    maxWidth: "auto",
    width: "fit-content",
    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    padding: "16px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    fontSize: 20,
    color: "rgba(0, 0, 0, 0.5)",
    "&::before": {
      boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    },
  },
}));

export default HtmlTooltip;
